import {IMapControlOptions, IMapControlService} from "./map-control-service";

export class OEMapControlService implements IMapControlService {
	public static $inject = [];

	public constructor() {

	}
	getControlOptions(): IMapControlOptions {
		return {
			hasOverviewMap: true,
			transparencySlider: true,
			hasGeolocation: true,
			hasContextMenu: true,
			hasAddPinButton: false,
			hasMobileSettingsButton: true
		}
	}
}